<template>
  <div>
    <div class="top_tit">
      <div class="line"></div>
      <p>{{ url.Name }}</p>
    </div>
    <div class="bottom_content">
      <div
        v-if="url.Content != '' && url.Content !== null"
        class="list_item"
        @click="openUrl(url.Content)"
      >
        <div class="list_right">
          <van-icon color="#888" name="link-o" size="20px" />
        </div>
        <p
          style="
            font-size: 12px;
            color: #b57e48;
            word-wrap: break-word;
            width: 80%;
          "
        >
          {{ url.Content }}
        </p>
      </div>
      <van-empty v-else description="暂无URL" image-size="40" />
    </div>
  </div>
  <!-- <OpenIframe ref="OpenIframe" /> -->
</template>

<script>
  import { ref, onActivated, onDeactivated, onMounted } from 'vue'
  // import router from '@/router'
  // import OpenIframe from '@/components/OpenIframe'
  export default {
    components: {
      // OpenIframe,
    },
    props: {
      // eslint-disable-next-line vue/require-default-prop
      url: {
        type: Object,
      },
    },
    setup(props) {
      const OpenIframe = ref(null)
      const openUrl = (url) => {
        // if (url.substring(0, 5) === 'https') {
        //   OpenIframe.value.show(url, '查看链接')
        // } else {
        goUrl(url)
        // }
      }
      const goUrl = (url) => {
        window.open(url)
      }

      return {
        goUrl,
        openUrl,
        // OpenIframe,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .bottom_content {
    padding-top: 15px;
    min-height: 75px !important;
  }

  .list_item {
    width: 100%;
    padding: 6px 10px;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #e8e8e9;
    box-shadow: 0px 0px 5px 0px rgba(232, 232, 233, 0.88);
    border-radius: 9px;
    margin: 0 0 15px 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .list_right {
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      box-shadow: 0 0 2px 0 #eee;
      margin-right: 10px;
    }
    ul {
      li {
        .list_top {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 0 15px;
          .list_left {
            padding: 10px 0;
            h3 {
              padding: 0;
              margin: 0;
              margin-bottom: 8px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #888;
            }
            p {
              padding: 0;
              margin: 0;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #4f515f;
            }
          }
          .list_right {
            width: 40px;
            height: 40px;
            border-radius: 4px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .list_bottom {
          padding: 0 15px;
          border-top: 1px solid #e8e8e9;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding-top: 5px;
          p {
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #b57e48;
          }
        }
      }
    }
  }
</style>
